import { FormElement, FormId } from "../../../../../components/enums";
import {
  ComplexFormSchemaComponents,
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { Url } from "../../../../../router/enums";
import { selectDamagesImagesDescriptionData } from "../damages.selectors";

import { ComponentId } from "./enums";

export const form: FormSchema<
  SimpleFormSchemaComponents | ComplexFormSchemaComponents
> = {
  formId: FormId.DAMAGES_IMAGES_DESCRIPTION,
  selector: selectDamagesImagesDescriptionData,
  redirect: Url.OC_VEHICLE_SUMMARY,
  content: [
    {
      sections: [
        {
          id: "damages-images-description-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.DESCRIPTION,
              label: "Opis uszkodzeń pojazdu poszkodowanego",
              required: true,
              limit: 1000,
              placeholder:
                "Opisz uszkodzenia swojego pojazdu (np.:przedni zderzak, przedni lewy błotnik, reflektor przedni).",
            },
          ],
        },
        {
          id: "damages-images-description-data-2",
          title: "Dodaj zdjęcia pojazdu w odpowiednie miejsce",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_SINGLE,
              id: ComponentId.FRONT_IMAGE,
              imageSectionId: ComponentId.DAMAGE_IMAGES,
              imageId: ComponentId.FRONT_IMAGE,
              label:
                "Zdjęcie z przodu pojazdu po skosie, widoczna tablica rejestracyjna i bok.",
            },
            {
              type: FormElement.IMAGE_UPLOADER_SINGLE,
              id: ComponentId.BACK_IMAGE,
              imageSectionId: ComponentId.DAMAGE_IMAGES,
              imageId: ComponentId.BACK_IMAGE,
              label:
                "Zdjęcie z tyłu pojazdu po skosie, widoczna tablica rejestracyjna i bok.",
            },
          ],
        },
        {
          id: "damages-images-description-data-3",
          title:
            "Dodaj maksymalnie 10 szczegółowych zdjęć uszkodzeń pojazdu, numer VIN, miejsce zdarzenia itd.",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_MULTIPLE,
              id: ComponentId.ADDITIONAL_IMAGES,
              maxImageNumber: 10,
              ignoredKeys: [ComponentId.BACK_IMAGE, ComponentId.FRONT_IMAGE],
              imageSectionId: ComponentId.ADDITIONAL_IMAGES,
            },
          ],
        },
      ],
    },
  ],
};
